module.exports = __webpack_public_path__ + "static/media/012.339ef9ae.jpg";